module.exports = __webpack_public_path__ + "static/media/mascot.ec33b56f.svg";